import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
export default function CommonQuestions() {
  const faqs = [{
    question: "What is included in the M / O Protocol membership?",
    answer: "Our memberships provide exclusive access to our wellness rooms, preferred pricing on IV therapy and vitamin injections, and monthly credits for services like sauna and colon hydrotherapy."
  }, {
    question: "How do I book my monthly wellness services?",
    answer: "Members can easily schedule their sessions through our integrated Mangomint booking system or via our mobile app, ensuring priority access to our most popular time slots."
  }, {
    question: "Can I share my membership benefits with family?",
    answer: "While memberships are individual, we offer special 'Plus One' add-ons that allow you to bring a guest for specific treatments at a significantly reduced member rate."
  }, {
    question: "Is there a long-term commitment required?",
    answer: "We believe in flexibility. While we offer annual plans for the best value, we also provide month-to-month options that can be paused or cancelled with 30 days' notice."
  }, {
    question: "Where are your wellness centers located?",
    answer: "We proudly serve the West Texas community with premium facilities in Midland and Odessa, both designed to provide a calming, luxury medical spa experience."
  }];
  return <section data-section-id="222510" id="membership-faq" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-accent/30 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-normal tracking-tighter text-primary">
            Membership FAQ
          </h2>
          <p className="mt-4 text-muted-foreground font-default max-w-2xl mx-auto text-lg">
            Everything you need to know about joining the M / O Protocol community
            and elevating your wellness journey.
          </p>
        </div>

        <div className="relative border border-border bg-card/50 backdrop-blur-sm p-6 md:p-10 rounded-lg shadow-sm">
          {}
          <div className="absolute -top-3 left-6 md:left-10 bg-background px-2">
            <Badge variant="outline" className="uppercase tracking-widest text-xs font-default font-semibold border-border text-primary">
              Details
            </Badge>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-b border-border/50 last:border-0 group">
                <AccordionTrigger className="hover:no-underline hover:bg-accent/20 px-4 py-6 transition-colors duration-300">
                  <h4 className="font-default text-lg md:text-xl font-medium text-left text-foreground group-hover:text-primary transition-colors">
                    {faq.question}
                  </h4>
                </AccordionTrigger>
                <AccordionContent className="px-4 pb-6 font-default text-muted-foreground text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}